module.exports = __webpack_public_path__ + "static/media/F22.38c17d19.png";